import React from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import ScrollToTop from '../components/ScrollToTop';
import Gallery from '../components/Gallery';


const Home = () => {

    return (
        <>
        <ScrollToTop />
            <Hero />
            <Portfolio />
            <Intro />
            <Services />
            <Gallery/>
            <Clients />
            <Footer />
        </>

    )
}

export default Home;

